import styled from "styled-components";

export const Container = styled.div`
display: flex;
/* justify-content: space-between; */
flex-direction:column ;
align-items: center;

.title{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    h1{
        font-weight: 600;
    }
}

.amount-container{
    width: 100%;
    margin-top: 3rem;
    display: flex;
    gap: 2rem;
      @media (max-width: 900px) {
            flex-wrap: wrap;
        }

    .amount-cart{
        border: 2px solid #C7C7C7;
        border-radius: 1rem;
        padding: 1.5rem; 
        width: auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        @media (max-width: 900px) {
            width: 31%;
        }
        @media (max-width: 640px) {
            width: 42%;
        }

        h1{
            font-weight: 600;
        }

        .amount{
            display: flex;
            justify-content: center;
            align-items: baseline;
            
            h3{
                font-size: 8rem;
            }
            h4{
                font-size: 3rem;
            }
        }
    }
}

`